import { render, staticRenderFns } from "./travel-assistant.vue?vue&type=template&id=fe198eea&scoped=true"
import script from "./travel-assistant.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-assistant.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-assistant.vue?vue&type=style&index=0&id=fe198eea&prod&lang=less"
import style1 from "./travel-assistant.vue?vue&type=style&index=1&id=fe198eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe198eea",
  null
  
)

export default component.exports